import { useEffect, useState, useContext } from "react";
import Repo from "../../Utility/Repo";
import { useLocation } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import {
  OnResultFunction,
  QrReader,
  QrReaderProps,
  UseQrReaderHook,
  UseQrReaderHookProps,
  useQrReader,
} from "react-qr-reader";
import { Button } from "design-react-kit";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ViewQCode = () => {
  const [couponData, setCouponData] = useState("Nessun risultato");
  const [user, setUser] = useState({});
  const [executive, setExecutive] = useState({});

  const [message, setMessage] = useState("");

  let query = useQuery();

  const apiToken = useContext(TokenContext);

  const [showDialog, setDiaglog] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  //fine da verificare

  const isButtonDisabled =
    message.startsWith("ERRORE:") || couponData.maxMonthlyUsage === 0;

  useEffect(() => {
    // Simulazione di una chiamata API per ottenere i dati del coupon
    if (query.get("id")) {
      scansiona(apiToken, query.get("id"));
    }
  }, []);

  const useCoupon = () => {
    if (couponData) {
      // Nessun errore, procedi con l'aggiornamento
      Repo.UseCoupon(apiToken, couponData.id)
        .then((response) => {
          if (response.status === 200) {
            setMessage(response.data);
            isButtonDisabled = true;
          } else if (response.status === 400) {
            // La chiamata ha restituito un errore Bad Request (400)
            setMessage(response.data);
          } else {
            // Altri codici di stato possono essere gestiti qui
            setMessage(`Errore: ${response.status} - ${response.statusText}`);
          }
        })
        .catch((error) => {
          Repo.handleApiError(error, setErrorMessage);
          console.error(errorMessage);
          setMessage("ERRORE: " + errorMessage);
        });
    } else {
      setMessage("ERRORE:", couponData);
    }

    // Puoi fare ulteriori azioni con i dati qui, ad esempio aggiornare lo stato del tuo componente
  };

  const scansiona = (apiToken, id) => {
    setMessage("");
    Repo.ViewCoupon(apiToken, id)
      .then((response) => {
        if (response.status === 200) {
          // onUpdate(formData);
          setCouponData(response.data);
          setUser(response.data.user);
          setExecutive(response.data.executive);
          setDiaglog(true);

          if (!response.data.isAutorize) {
            setMessage("ERRORE: NON SEI AUTORIZZATO A VALIDARE QUESTO BUONO!");
          }
        } else if (response.status === 400) {
          // La chiamata ha restituito un errore Bad Request (400)
          setCouponData(response.statusText);
        } else {
          // Altri codici di stato possono essere gestiti qui
        }
      })
      .catch((error) => {
        setCouponData(error.message);
      });
  };

  const clearScan = async () => {
    setProcessing(false);
    setDiaglog(false);
  };

  const handleScan = async (scanData) => {
    if (scanData && scanData !== "" && !showDialog && !processing) {
      const text = scanData.text;
      const startIndex = text.lastIndexOf("=") + 1;
      const id = text.substring(startIndex);

      setProcessing(true);
      scansiona(apiToken, id);
    }
  };

  const handleError = (err) => {
    console.error("Errore nella scansione del QR Code:", err);
  };

  return (
    <>
      <div>
        <h1>Buono servizio</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Verifica i dati e convalida il buono servizio</p>
        </div>

        {!showDialog && !processing && (
          <>
            <QrReader
              delay={50}
              onError={handleError}
              onScan={handleScan}
              onResult={handleScan}
              style={{ width: "100%", heigth: "100px" }}
              constraints={{
                facingMode: "environment",
                focusMode: "continuous",
              }}
            />
          </>
        )}

        {showDialog && (
          <div className="card-wrapper card-space">
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="row m-3">
                {couponData ? (
                  <div className="col-12">
                    <h4>{couponData.title}</h4>
                    <p>
                      Valore: <b>{couponData.valore}€</b>
                    </p>
                    <p>
                      Validità: <b>{couponData.dataInizioValidita}</b> al{" "}
                      <b>{couponData.dataFineValidita}</b>
                    </p>

                    <p>
                      Utilizzi rimasti: <b>{couponData.maxMonthlyUsage}</b>
                      {couponData.maxMonthlyUsage === 0 && ( // Mostra il testo in rosso se maxMonthlyUsage è 0
                        <span
                          style={{
                            color: "red",
                            marginLeft: "10px",
                            fontWeight: "600",
                          }}
                        >
                          UTILIZZI TERMINATI
                        </span>
                      )}
                    </p>

                    <hr />
                    <h4>Utente:</h4>
                    <p>
                      Utente:{" "}
                      <b>
                        {user.firstName.toUpperCase() ?? "N/D"}{" "}
                        {user.lastName.toUpperCase() ?? "N/D"}
                      </b>
                    </p>
                    <p>
                      CF: <b>{user.fiscalCode.toUpperCase() ?? "N/D"}</b>
                    </p>
                    <p>
                      Email: <b>{user.email.toUpperCase() ?? "N/D"}</b>
                    </p>
                    <hr />
                    {/*     <h4>Esercente:</h4>
                    <p>
                      Soggetto: <b>{executive.name ?? "N/D"} </b>
                    </p>
                    <p>
                      Partita iva: <b>{executive.pIva ?? "N/D"}</b>
                    </p>
                    <p>
                      Indirizzo: <b>{executive.address ?? "N/D"}</b>
                    </p>

                        Aggiungi altri campi del coupon e dell'utente secondo necessità */}
                  </div>
                ) : (
                  <p>Caricamento in corso...</p>
                )}
              </div>
              <hr />

              {message && (
                <div
                  className={`alert ${
                    message.startsWith("ERRORE:")
                      ? "alert-danger"
                      : "alert-success"
                  } mt-2`}
                  role="alert"
                >
                  <b>
                    {message.startsWith("ERRORE:") ? "Attenzione" : "Successo"}:
                  </b>{" "}
                  {message}.
                </div>
              )}
              <div className="row m-2">
                <div className="col-6 d-flex justify-content-center">
                  <Button
                    className="btn btn-warning"
                    type="button"
                    onClick={() => {
                      clearScan();
                    }}
                  >
                    SCANNERIZZA NUOVO BUONO
                  </Button>
                </div>
                <div className="col-6 d-flex justify-content-center">
                  <Button
                    className="btn btn-success"
                    type="button"
                    disabled={isButtonDisabled}
                    onClick={() => {
                      useCoupon();
                    }}
                  >
                    CONFERMA VALIDAZIONE
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewQCode;
